import React from "react";
import { useSelector } from "react-redux";

const Tab = ({ title, setTitle, fullPage = false }) => {
  const { menuDrawer } = useSelector((store) => store.app);

  return (
    <div
      className={`flex fixed h-[3.6rem] no-scrollbar::-webkit-scrollbar no-scrollbar overflow-x-auto scrollbar-hidden bg-surface z-[20] pr-[1rem] border-neutral-50 border-b-[1px] ${
        fullPage
          ? `top-[7.125rem] right-[1.5rem] pl-[1.5rem] ${
              menuDrawer ? "left-[5rem]" : "left-[13rem]"
            }`
          : "top-[3.55rem] w-[67%]"
      }`}
    >
      {[
        "Hotel Details",
        "Nearby Attraction",
        "Payment settings",
        "Social Links",
        "Price Settings"
      ]?.map((tabTitle) => (
        <button
          key={tabTitle}
          onClick={() => setTitle(tabTitle)}
          className={`${
            title === tabTitle
              ? "text-primary border-b-primary font-[500]"
              : "text-fg-muted border-b-neutral-50 font-[400]"
          } bg-surface border-b-[1px] font-body   text-[14px] leading-[18px] px-6 whitespace-nowrap`}
        >
          {tabTitle}
        </button>
      ))}
    </div>
  );
};
export default Tab;
/*
"dayWiseDiscountMap": {
      "0": 0,
      "7": 6,
      "10": 10
    }
*/